
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Nama Merchant', value: 'nama_merchant'},
  { text: 'Nama Outlet', value: 'nama_outlet'},
  { text: 'MID', value: 'mid'},
  { text: 'NMID', value: 'nmid'},
  { text: 'Alamat Lengkap', value: 'address', width: '250'},
  { text: 'Kriteria Merchant', value: 'merchant_criteria'},
  { text: 'Email', value: 'email'},
  { text: 'No Handphone', value: 'mobile_phone'},
  { text: 'Jenis QR', value: 'qr_type', align: 'center', textAlign: 'text-center'},
  { text: 'Action', value: 'action', width: '10' }
]);


export const search = {
  mid: '', 
};
